import Reveal from "Components/marketing/Reveal";

/**
 * One idea, one viewport — the deck's core layout translated to the portal.
 *
 * An oversized statement headline with a single coloured keyword, an optional
 * eyebrow, and supporting content beneath. Presentational only.
 */
function StatementSection({
  eyebrow,
  title,
  lede,
  children,
  accent = "coral",
  align = "left",
  className = "",
  id,
}) {
  const titleColor =
    accent === "coral"
      ? "text-[hsl(var(--brand-coral))]"
      : accent === "lavender"
        ? "text-[hsl(var(--brand-lavender))]"
        : "text-foreground";

  return (
    <section
      id={id}
      className={`py-20 md:py-28 ${className}`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className={align === "center" ? "mx-auto max-w-3xl text-center" : ""}>
          {eyebrow && (
            <Reveal>
              <p className="mb-5 text-xs font-semibold uppercase tracking-[0.16em] text-[hsl(var(--brand-coral))]">
                {eyebrow}
              </p>
            </Reveal>
          )}

          {title && (
            <Reveal delay={60}>
              <h2
                className={`text-statement max-w-[18ch] text-4xl md:text-5xl lg:text-6xl ${titleColor} ${
                  align === "center" ? "mx-auto" : ""
                }`}
              >
                {title}
              </h2>
            </Reveal>
          )}

          {lede && (
            <Reveal delay={120}>
              <p
                className={`mt-6 max-w-[58ch] text-lg leading-relaxed text-muted-foreground ${
                  align === "center" ? "mx-auto" : ""
                }`}
              >
                {lede}
              </p>
            </Reveal>
          )}
        </div>

        {children}
      </div>
    </section>
  );
}

export default StatementSection;
